import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import KJ from '../Music/KJ'


const MusicBanner = (props) => {
    const [showModal, setShowModal] = useState(false)
    
    return (
        <>
        <Container style={{height:'40vh', display:'flex', flexDirection:'column', justifyContent:'end', boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.5)'}} id="backgroundKaraokeBanner" bg="dark" className="pb-4" onClick={() => {
            setShowModal(true)
        }} >
            
            <Row style={{}}>
                <Col className="text-center text-strong text-glow-pink ">
                    <span className="text-bg-black text-center m-2">Support Queer Music</span>
                </Col>
            </Row>
            <Row>
                <Col className="text-center">
                    <Button size="lg">Learn More</Button>
                </Col> 
            </Row>
            
                    
        </Container>
        <Modal
            id="promoModal"
            centered="true"
            show={showModal}
            onHide={() => {setShowModal(false)}}
            scrollable
            style={{color: 'black'}}
        >
            <Modal.Header closeButton>
                <h2>Support a Local Artist</h2>
            </Modal.Header>
            <Modal.Body id="promoBody" style={{maxHeight:'75vh'}}>
                <KJ />
            </Modal.Body>
        </Modal>
        </>
    )
}

export default MusicBanner